import Icon from '../../tc-ui/icon';
import React, { createClass, PropTypes } from 'react';

const ConnectionsFilterItem = createClass({

  propTypes: {
    action: PropTypes.func,
    isTypeAheadTag: PropTypes.bool,
    name: PropTypes.string,
  },

  removeTag() {
    const { action, isTypeAheadTag, name } = this.props;
    if (isTypeAheadTag) {
      return action(name, 'remove');
    }
    action(name, true);
  },

  render() {
    return (
      <div className="connections-tag-contianer">
        <div className="connections-tag-name">
          {this.props.name}
        </div>
        <Icon className="tc-icon-close" onClick={this.removeTag} />
      </div>
    );
  },
});

export default ConnectionsFilterItem;



// WEBPACK FOOTER //
// ./src/app/components/connections/connections-toolbar/connections-filter-item.jsx